import React from 'react';
import { CommonDeleteModal } from 'components/common';
import { useDeleteModal } from 'feature/clientTabs/payments/specialPricingRules/delete/useDeleteModal';

interface IDeleteModal {
  openModal: boolean;
  dataToDelete: { id: string | undefined };
  onDeleteModalClose: () => void;
}

export const DeleteModal = (props: IDeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={onDeleteModalClose}
        isLoading={isLoading}
        open={openModal}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={onDeleteModalClose}
        title={'Delete Special Pricing Rule'}
        message={'Are you sure you want to delete this Special Pricing Rule?'}
      />
    </>
  );
};
